import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch, useSelector } from "react-redux";
import { setTimezone } from "../redux/globalDataSlice";
import TimezoneSelect from "react-timezone-select";
import { timezoneOptions } from "../utils/dateTime";

export default function Topbar({
  onMobileMenuClick,
  onDesktopToggleClick,
  collapsed,
}) {
  const dispatch = useDispatch();
  const timezone = useSelector((state) => state.globalData.timezone);
  const [pendingTimezone, setPendingTimezone] = useState(null);

  const handleTimezoneChange = (selected) => {
    const nextTimezone = selected?.value ?? null;
    if (nextTimezone === timezone) return;
    setPendingTimezone(nextTimezone);
  };

  const handleConfirm = () => {
    window.localStorage.setItem("selectedTimezone", pendingTimezone);
    dispatch(setTimezone(pendingTimezone));
    window.location.reload();
  };

  const handleCancel = () => setPendingTimezone(null);

  return (
    <>
    <Dialog open={!!pendingTimezone} onClose={handleCancel}>
      <DialogTitle>Reload page?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Changing the timezone will reload the page. Do you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
    <AppBar
      position="fixed"
      sx={{
        background: "#fff",
        color: "#111827",
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar>
        {/* Mobile hamburger */}
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMobileMenuClick}
          sx={{ mr: 1, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Desktop collapse */}
        <IconButton
          color="inherit"
          edge="start"
          onClick={onDesktopToggleClick}
          sx={{ mr: 1, display: { xs: "none", sm: "inline-flex" } }}
        >
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>

        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Pricing Rules
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ minWidth: 260, mb: 1, mt: 1 }}>
          <Typography variant="body2" sx={{ mb: 0.5}} color="info">
            Timezone
          </Typography>
          <TimezoneSelect
            value={timezone}
            onChange={handleTimezoneChange}
            placeholder="Select timezone..."
            timezones={timezoneOptions}
            styles={{
              control: (base) => ({
                ...base,
                fontSize: "0.875rem",
                borderColor: "#c4c4c4",
                boxShadow: "none",
                "&:hover": { borderColor: "#111827" },
              }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
              singleValue: (base) => ({ ...base, color: "#111827" }),
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
    </>
  );
}
